
export const OPEN_CUSTOMER_DISPLAY = "OPEN_CUSTOMER_DISPLAY";
export const CLOSE_CUSTOMER_DISPLAY = "CLOSE_CUSTOMER_DISPLAY";
export const SHOW_MISSING_PERMISSIONS = "SHOW_MISSING_PERMISSIONS";
export const HIDE_MISSING_PERMISSIONS = "HIDE_MISSING_PERMISSIONS";

export interface OpenCustomerDisplayAction {
    type: typeof OPEN_CUSTOMER_DISPLAY;
}

interface CloseCustomerDisplayAction {
    type: typeof CLOSE_CUSTOMER_DISPLAY;
}

interface ShowMissingPermissionsDisplayAction {
    type: typeof SHOW_MISSING_PERMISSIONS;
}

interface HideMissingPermissionsDisplayAction {
    type: typeof HIDE_MISSING_PERMISSIONS;
}

export type CustomerDisplayActionTypes = OpenCustomerDisplayAction |
    CloseCustomerDisplayAction |
    ShowMissingPermissionsDisplayAction |
    HideMissingPermissionsDisplayAction;

export interface CustomerDisplayState {
    visible: number;
    missingPermissions: boolean;
}

export function openCustomerDisplay(): CustomerDisplayActionTypes {
    return {
        type: OPEN_CUSTOMER_DISPLAY,
    };
}

export function closeCustomerDisplay(): CustomerDisplayActionTypes {
    return {
        type: CLOSE_CUSTOMER_DISPLAY,
    };
}

export function showMissingPermissions(): CustomerDisplayActionTypes {
    return {
        type: SHOW_MISSING_PERMISSIONS,
    };
}

export function hideMissingPermissions(): CustomerDisplayActionTypes {
    return {
        type: HIDE_MISSING_PERMISSIONS,
    };
}
